<script type="text/jsx" lang="jsx">
import { mapGetters } from "vuex";
import BuyTrial from './buy-trial';
import AddTrial from './add-trial';
import BuyNow from './buy-now';
import BuyNowTrial from './buy-now-trial'
import EditDelta from "./edit-delta.vue";
import EditSimple from "./edit-simple.vue";
import planPropsMixin from "@/plans/mx/plan-props";
import { planTypes } from '@/common/constants';
import { plansof } from '@/utils/chain';
import { openPlanSelectionDialogIfNeeded } from '@/plans/common/plan-selection-dialog-service';

export default {
  mixins: [planPropsMixin],
  computed: {
    ...mapGetters(['getSelectedPlans']),
  },
  created() {
    openPlanSelectionDialogIfNeeded();
  },
  render() {
    const context = {...this.$props, ...this.$attrs};

    if (this.$context.is.buyTrial) return <BuyTrial {...context} />;
    if (this.$context.is.add2trial) return <AddTrial {...context} />;
    if (this.$context.is.buyNow || this.$context.is.basic2pro) {
      if (plansof(this.getSelectedPlans).type(planTypes.ZOOM_SCHEDULER).get(0).isOnlineFreeTrial) {
        return <BuyNowTrial {...context} />
      }
    }

    if (this.$context.is.edit) {
      if (this.$context.is.simplify) {
        return <EditSimple />;
      }
      if (this.$context.is.addQty) {
        return <EditDelta {...context} />;
      }
    }
    return <BuyNow {...context} />;
  },
};
</script>
